import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/App';
import { bootstrapSupabaseConfig } from '@/lib/supabaseClient';

// ---------------------------------------------------------------------------
// Runtime bootstrap (Phase 81.5.4 + v3.6.9 Phase 84.28.7 hardening).
//
// Fetch the environment-scoped Supabase URL + anon key from
// `GET /api/public-config` BEFORE React renders. See the header comment in
// `lib/supabaseClient.js` for the full rationale. If the bootstrap fails
// (e.g. backend unreachable, or serving an older build without the endpoint),
// the fallback path in supabaseClient.js uses the baked-in `REACT_APP_*`
// values so we never render a broken app.
//
// v3.6.9 Phase 84.28.7 — the fetch loop inside `bootstrapSupabaseConfig()`
// now does its own 2 attempts × 4-second cap, so this outer wrapper is
// primarily a safety net. We keep an 8-second overall cap here in case
// the internal loop somehow hangs — historically that's never happened,
// but a stuck AbortController would leave the app blank without this.
//
// The login page (src/pages/Login.js) reads `getBootstrapStatus()` and
// displays a "Connecting securely…" state with a Retry button when the
// runtime config didn't resolve, so a fallback path never silently
// submits credentials to a potentially-wrong Supabase project.
// ---------------------------------------------------------------------------
function withTimeout(p, ms) {
  return Promise.race([
    p,
    new Promise((resolve) => setTimeout(resolve, ms)),
  ]);
}

async function main() {
  try {
    await withTimeout(bootstrapSupabaseConfig(), 8000);
  } catch (e) {
    if (typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn('[2120] bootstrap failed, using baked-in Supabase config:', e);
    }
  }
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<App />);
}

main();
